var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-card-wrapper"},[_c('div',{staticClass:"content"},[_c('avatar',{attrs:{"src":_vm.profile.avatar}}),_c('div',{staticClass:"basic"},[_c('span',{staticClass:"nick text-ellipsis"},[_vm._v(_vm._s(_vm.profile.nick || _vm.profile.userID))]),_c('span',{staticClass:"iconfont",class:_vm.genderClass})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }